import { useUiStrings } from '@/hooks/useUiStrings'
import { useStore } from '@/store/useStore'

/**
 * Reports a meeting that started but could not be shared (BRAI-533).
 *
 * Mounted app-wide rather than in the create modal: the modal closes and the
 * app navigates to the live screen the instant the meeting is created, so a
 * message rendered there would unmount before anyone read it. Dismissed by the
 * user, never on a timer — the recovery step (share it again from History) is
 * something they have to act on.
 */
export default function ShareOnCreateErrorNotice() {
  const { t } = useUiStrings()
  const message = useStore((s) => s.shareOnCreateError)
  const setMessage = useStore((s) => s.setShareOnCreateError)

  if (!message) return null

  return (
    <div
      role="alert"
      className="fixed inset-x-4 top-4 z-[60] mx-auto max-w-lg rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700 shadow-lg dark:border-red-500/40 dark:bg-red-500/10 dark:text-red-200"
    >
      <div className="flex items-start justify-between gap-3">
        <p>{message}</p>
        <button
          type="button"
          onClick={() => setMessage(null)}
          className="shrink-0 text-red-500 hover:text-red-700"
          aria-label={t.close}
        >
          ×
        </button>
      </div>
    </div>
  )
}
